import React from 'react';
import { TRAINING_TYPE_IDS, TrainingHeadersType } from '.';
import TextLabel from '../TextLabel';
import { capitalizeFirstLetter } from '../helper';

interface TrainingHeadersProps {
    qualificationTypeList: TrainingHeadersType[];
    handleQualificationTypeClick: (paramsId: number, title: string) => void;
}
const TrainingHeaders = ({ qualificationTypeList, handleQualificationTypeClick }: TrainingHeadersProps) => {

    return (
        <React.Fragment>
            {(qualificationTypeList || []).map(({ name, id }) => (
                <th key={id} onClick={() => handleQualificationTypeClick(id, name)}><TextLabel type='tableHeader'> {name} </TextLabel></th>
            ))}
        </React.Fragment>
    );
};

export default TrainingHeaders;